
export default {
    name: 'BaseDialog',
    props: {
        dialog: {
            type: Boolean,
            default: false,
            required: true
        },
        title: {
            type: String,
            default: '',
            required: false
        }
    },
    emits: ['close', 'sumbitData'],
    computed: {
        showDialog: {
            get() {
                return this.dialog;
            },
            set() {
                this.closeModal();
            }
        }
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        async submitData() {
            const { valid } = await this.$refs.form.validate();
            if (!valid) return;

            this.$emit('sumbitData');
        }
    }
};
